import React, { useContext, useState, useCallback } from "react";
import { FlatList, Dimensions, StyleSheet, View } from "react-native";
import { useFocusEffect } from '@react-navigation/native';

import ActivityIndicator from "../components/ActivityIndicator";
//import Button from "../components/Button";
//import Card from "../components/Card";
import colors from "../config/colors";
//import listingsApi from "../api/listings";
import routes from "../navigation/routes";
import Screen from "../components/Screen";
//import AppText from "../components/Text";
//import useApi from "../hooks/useApi";
//import { object } from "yup";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
//import useAuth from "../auth/useAuth";
import dateNow from "../utility/dateNow";
//import { useLinkProps } from "@react-navigation/native";
import { Audio } from "expo-av";
// import { MaterialCommunityIcons, 
//   AntDesign, 
//   Fontisto, 
//   Octicons, 
//   FontAwesome5, 
//   Entypo  } from "@expo/vector-icons";
import CardListing from "../components/CardListing";
import AuthContext from "../auth/context";

  var pointer = 0
  var blockSize = 60
  var pageNumber = 0
  var arraySeeds = []

function ListingsSeedsScreen({ route, navigation }) {
 //debugger
 useFocusEffect(
  useCallback(() => {
  debugger 
  setListing(route.params.items) 
  pageNumber = route.params.pageNumber
  arraySeeds = []
  pointer = 0
  //getSeeds()
}, [route.params.items, route.params.index])
);


const [loading, setLoading] = useState(false)
const [ listing, setListing] =  useState([])// llena la lista de semillas
var webUrl = connectionConfig.imageUrl + '/seedImages/'
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'

var foundUserChecker = route.params.foundUserChecker

//const { user } = useAuth();
const { user, setUser } = useContext(AuthContext);
const date = dateNow();
var indexLike = 0
var numLikes = 0
const WIDTH = (Dimensions.get('window').width) / 2;
const HEIGHT = 419.7       //419.95  //4.19698  //419.6994076923077 //315.2727355957031
  //(Dimensions.get('window').height) * .5;
  

  const sizeItemLayout = (listing, index) => (
    {length: HEIGHT, offset: HEIGHT * index, index}
  );

  const getPublications = async () => {
    //debugger
    pointer = pageNumber * blockSize
    setLoading(true)
    var post_values = {
      userId: JSON.parse(user).userId,
      pointer: pointer,
      blockSize: blockSize
    }
    //establece parámetros de configurción del post
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para adquirir los pubicaciones del servidor
    await fetch(connectionConfig.apiUrl + '/selectPubications/', configurationPost)
      .then(response => response.json())
      .then(response => {
        if (response.data.length === 0) {
          if (pageNumber > 0) {
            setLoading(false)
          } else {
            setPublicationSucces(false)
            setLoading(false)
          }
        } else {
          pageNumber++
          if (arrayPublications.length > 0) {
            arrayPublications = [...arrayPublications, ...response.data]
          } else {
            arrayPublications = response.data
          }
          setItems(arrayPublications)
          setLoading(false)
          setPublicationSucces(true)
        }
      })
      .catch(err => {
        console.log('getPublications failed :( review internet service)', err)
      })
  }

  const getSeeds = async () => {
    debugger
    pointer = pageNumber * blockSize  
    setLoading(true)
    var post_values = {
        //userId : userId
       userId : route.params.userId,
       pointer: pointer,
       blockSize : blockSize
    }
    //establece parámetros de configurción del post
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para adquirir los pubicaciones del servidor
    await fetch(connectionConfig.apiUrl+'/selectMosaicSeed/', configurationPost)
      .then(response => response.json())
      .then(response => {
        if(response.data.length === 0) {
          if(pageNumber > 0){
            setLoading(false)
          }else{
            setLoading(false)
        }
      }else{
        pageNumber ++  
          if (arraySeeds.length > 0) {
            arraySeeds = [ ...arraySeeds, ...response.data]
          }else{
              arraySeeds = response.data
          }
          setListing(arraySeeds) 
          setLoading(false)
        }
      })
      .catch(err =>{
           console.log('getSeeds failed :( review internet service -> /selectMosaicSeed/', err )
      })  
}

//-----------------------------------------------------------------------------------------------------------------------
// 1. Servicio que valida si ya existe el like del usuario en la publicación (función inicio del encadenamiento de servicios) 
//-----------------------------------------------------------------------------------------------------------------------
const onPressValidationLikeUser = async () => {
  try {
    const { sound } = await Audio.Sound.createAsync(
      require('../assets/sounds/ringtones-heart.mp3')   // Ejecuta un sonido al hacer like  
    )
    await sound.playAsync()
  } catch (error) {
    console.log(':(', err )
  }
  debugger
  var post_values = {
   seedId :  listing[indexLike].seedId,
   userId : JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/SelectValidateSeedsLikes/', configurationPost)
  .then(response => response.json())
  .then(response => {
    if (response.data.length != 0) {   
       deleteLikePublication()
    } else {
      insertLike()           
     }
  })
  .catch(err =>{
  console.log(':( review internet service', err )
  })
}

//--------------------------------------------------------
// 2. servicio que borra el like si ya existe en la publicación
//---------------------------------------------------------
const deleteLikePublication = async () => {
  var post_values = {
    seedId :  listing[indexLike].seedId,
    userId : JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/deleteLikeSeeds/', configurationPost)
  .then(response => response.json())
  .then(response => {
    countOfLikes()
   })
   .catch(err =>{
   console.log(':( review internet service /deleteLikeSeeds/', err )
   })
}   

//-------------------------
// 2.1. Agrega un nuevo like 
//-------------------------
const insertLike = async  () => {
   // debugger
  var post_values = {
      seedId : listing[indexLike].seedId, 
      userId : JSON.parse(user).userId,
      dateLikeSeed : date,
      likeType : 1
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/insertSeedLike/', configurationPost) 
  .then(response => response.json())
  .then(response => {
    countOfLikes()    
  })
  .catch(err =>{
  console.log('Insert fixo failed :( review internet service -> insertSeedLike', err )
  })
}

//------------------------------------------------------------------
// 3. Servicio que nos va a traer el count de likes por semilla.
//------------------------------------------------------------------
const countOfLikes = async () => {
   var post_values = {
      seedId : listing[indexLike].seedId, 
    }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/SelectCountSeedLikes/', configurationPost)
   .then(response => response.json())
   .then(response => {
     numLikes = response.data[0].total_likes
     incrementLikes()
     
   })
   .catch(err =>{ 
   console.log(':( review internet service => /SelectCountSeedLikes/', err )
   })
}
//------------------------------------------------------------------------------
// 4. servicio que hace un incremeto al campo de número de likes de una semilla
//------------------------------------------------------------------------------
const incrementLikes = async () => {
        //debugger

        var post_values = {
          seedId : listing[indexLike].seedId, 
          totalSeedLikes : numLikes
      }
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl+'/UpdateIncrementLikeSeeds/', configurationPost) 
      .then(response => response.json())
      .then(response => {
      refresPublications()
      })
      .catch(err =>{
      console.log('Insert fixo failed :( review internet service /UpdateIncrementLikeSeeds/', err )
      })
}
 //------------------------------------------------------------
 // 5. Busca la lista de publicaciones despues de haber hecho like función (termino)
 //------------------------------------------------------------ 
const refresPublications = async () => {
  //debugger
    var post_values = {
      userId    : listing[0].userId,
      pointer   : route.params.pointer,
      blockSize : route.params.blockSize
     }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/selectMosaicSeed/', configurationPost)
    .then(response => response.json())
    .then(response => {
      //debugger
      setListing(response.data)
    })
    .catch(err =>{
    console.log(':( review internet service /selectMosaicSeed/', err )
    })
}

//---------------------------------------------
// Función para regresar a UserFixoScreen
//---------------------------------------------
const returnToUserFixoScreen = async () => {
  navigation.navigate(routes.USER_FIXO )
}



  return (
    <>
      <ActivityIndicator visible={loading} />
      <Screen style={styles.screen}>
 
        <FlatList
          getItemLayout={sizeItemLayout}
          data={listing}
          keyExtractor={(listing) => listing.seedId.toString()}
          initialScrollIndex={route.params.index}
          onEndReachedThreshold={.5}
          onEndReached={() => getPublications()}
          renderItem={({ item, index}) => (
            // <View onLayout= {object => 
            //         itemHeights[index] = object.nativeEvent.layout.height}>
              <CardListing
                title={item.seedName}
                subTitle={item.totalSeedLikes} // 
                onPressNumLikes={() => {
                  indexLike = index
                  var seedId = listing[indexLike].seedId
                  navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId}  )
                  //console.log("presNumLique", indexLike)
                  }                  
                }
                imageUrl={
                  item.seedPhoto.includes('.mp4') ?
                  seedVideoUri + item.seedPhoto :
                  item.seedPhoto.includes('.mov') ?
                  seedVideoUri + item.seedPhoto :
                  webUrl + item.seedPhoto}
                
                onPress={() => {
                  var seedId = listing[index].seedId
                  var screen = 'ListingsSeedsScreen'//{screen: 'ListingsSeedsScreen'}
                  navigation.navigate(routes.SEED_DETAILS, {seedId, item, screen, foundUserChecker } )
                  }
                }

                onPressLike={ () => {
                  indexLike = index
                  onPressValidationLikeUser()
                 }
                }
                commentsNum={item.totalSeedComments}
                actionsNum={item.totalActions}
                onPressComment={() => {
                  indexLike = index
                  var seedId = listing[indexLike].seedId
                  navigation.navigate(routes.COMMENTS_SEEDS, {item, seedId})
                  }
                } 
                type={item.type}
                thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
              />
             
            //  </View>
          )}


        />
      </Screen>
      {/* <View style={styles.bottomMenu} >
          <MaterialCommunityIcons 
                name={"chevron-left"} 
                color={"green"} size={40} 
                onPress={ ()=> returnToUserFixoScreen() } 
                >
          </MaterialCommunityIcons> 
       </View> */}

    </>
  );
}

const styles = StyleSheet.create({
  screen: {
    padding: 5,
    backgroundColor: colors.light,
  },
  bottomMenu: {
    //paddingLeft: "12%",
    //padding: 7,
    flexDirection: "row",
    alignSelf: "flex-end",
    width: "100%",
    height: "10%",
    //marginVertical: 10,
    //alignItems: "center",
    backgroundColor: colors.fuente,
  },
});

export default ListingsSeedsScreen;
